import { angularInjectorProvider } from 'Injector';
import { unsetCurrentUser } from 'Authentication';
import { useNavigationHelper } from 'FrontRoyalAngular';
import { useCallback } from 'react';

export function useRedirectToSignIn() {
    const { loadRoute } = useNavigationHelper();

    const unsetCurrentUserAndRedirectToSignIn = useCallback(() => {
        // FIXME: this should not use reactRouterBridge, since we're in react. It should just use useLocation or useParams or whatever
        const reactRouterBridge = angularInjectorProvider.get<ng.ILocationService>('reactRouterBridge');
        const target = reactRouterBridge.url();
        const params = new URLSearchParams({ target });
        const route = `/sign-in?${params.toString()}`;

        // If we don't unset the current user, they could end up on the dashboard and just have the next
        // request fail
        unsetCurrentUser();
        loadRoute(route);
    }, [loadRoute]);

    return {
        unsetCurrentUserAndRedirectToSignIn,
    };
}
